//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

  import { queryAllList, updateData, deleteData, deleteBy, queryBy } from '../../assets/js/sql'
  import { pageCreate } from "@/api/create";
  import { Dialog } from 'vant';
  export default {
    name: "mychat",
    data: function() {
      return {
        title: "我的创作",
        active: 0,
        selectIds: [],
        allDataList: [],
        dataList: [],
        allList: [],
        createList: [],
        newList: [],
        tabList: ['全部会话', 'AI聊天', '我的创作'],
        // 兼容旧数据，以下type类型 为专家 db version 3 conversion无class分类字段
        specificTypes: ['医疗顾问', '学习顾问', '法律顾问', '私人厨房', '星象占卜', '旅游出行', '语言翻译', '美食探店', '营销策划', 'AI编程'],
        createTypes: ['小说', '作文', '论文', '诗歌情诗', '学习计划', '概括总结', '周报', '日程计划', '发言稿', 'AI绘画', '心情日志', '朋友圈文案', '个性签名'],
        titleIndex: 0,
        isEdit: false,
        selected: true,
        unSelected: false
      };
    },
    created() {
      if (navigator.userAgent.includes("AppleWebKit")) {
        this.isIphone = true;
      }
      // this.getData()
      // this.getList()
    },
    mounted() {},
    activated() {
      this.getData()
    },
    methods: {
      doEdit () {
        this.isEdit = true
        this.selectIds = []
        this.contentH = 46 + this.top + this.bottom + 60
      },
      cancelEdit () {
        this.isEdit = false
        this.resetSelected()
        this.contentH = 46 + this.top + this.bottom
      },
      getData () {
        pageCreate().then(res => {
          this.createList = res.data
          this.getList()
        })
      },
      getList () {
        queryAllList("conversation").then(res => {
          let dataList = res.data
          console.log(dataList)
          this.allDataList = []
          dataList.forEach(async item => {
            let results = this.createList.filter(c => c.type === item.type)
            if (results.length) {
              item.icon = results[0].picture
            } else {
              item.icon = ''
            }
            if (!item.class) {
              let specificTypes = this.specificTypes.join(',') // 专家的数据
              let createTypes = this.createTypes.join(',') // 专家的数据
              let className = ''
              if (createTypes.indexOf(item.type) !== -1) {
                className = 'create'
              }
              if (specificTypes.indexOf(item.type) !== -1) {
                className = 'specific'
              }
              item.class = className
              if (!item.updateTime) {
                item.updateTime = item.createTime
              }
              this.allDataList.push(item)
              console.log('update: ', item.id)
              updateData("conversation", item)
              console.log('updateDown: ', item.id)
            } else {
              this.allDataList.push(item)
            }
          });
          this.configData()
        })
      },
      configData() {
        this.allDataList.sort((a, b)=>{ return b.updateTime - a.updateTime})
        this.specificList = this.allDataList.filter(item => item.class === 'specific')
        this.createList = this.allDataList.filter(item => item.class === 'create')
        this.newList = this.allDataList.filter(item => item.class === 'new')
        this.allList = this.allDataList.filter(item => item.class === 'new' || item.class === 'create')
        switch (this.titleIndex) {
          case 0:
            this.dataList = this.allList
            break;
          case 1:
            this.dataList = this.newList
            break;
          case 2:
            this.dataList = this.createList
            break;
        }
        console.log('all', JSON.stringify(this.allDataList))
      },
      tabClick (index) {
        this.titleIndex = index
        this.configData()
      },
      selectAll () {
        if (this.selectIds.length !== this.dataList.length) {
          // 全选
          let dataList = JSON.parse(JSON.stringify(this.dataList))
          this.selectIds = this.dataList.map(item => item.id)
          dataList.forEach(item => item.selected = true);
          this.dataList = JSON.parse(JSON.stringify(dataList))
        } else {
          this.resetSelected()
        }
      },
      resetSelected() {
        // 取消全选
        this.selectIds = []
        let dataList = JSON.parse(JSON.stringify(this.dataList))
        dataList.forEach(item => item.selected = false);
        this.dataList = JSON.parse(JSON.stringify(dataList))
      },
      deleteMyChat () {
        console.log('删除会话', JSON.stringify(this.selectIds))
        if (!this.selectIds.length) {
          this.$toast('请选择会话')
          return
        }
        let _this = this
        Dialog.confirm({
          title: '提示',
          message: '确定要删除会话吗?',
          // confirmButtonColor: '#30b8b8',
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          // cancelButtonColor: '#999999',
        })
          .then(() => {
            _this.doDelDB()
          })
          .catch(() => { })
      },
      doDelDB() {
        let tempArr = []
        let alltempArr = []
        let allDataList = JSON.parse(JSON.stringify(this.allDataList))
        let dataList = JSON.parse(JSON.stringify(this.dataList))
        this.selectIds.forEach(item => {
          this.queryConversationDetailData(item)
          this.removeConversationData(item)
        })
        dataList.forEach(item => {
          if (!this.selectIds.includes(item.id)) {
            tempArr.push(item)
          }
        })
        allDataList.forEach(item => {
          if (!this.selectIds.includes(item.id)) {
            alltempArr.push(item)
          }
        })
        this.allDataList = JSON.parse(JSON.stringify(alltempArr))
        this.dataList = JSON.parse(JSON.stringify(tempArr))
        this.selectIds = []
        this.isEdit = false
      },
      async queryConversationDetailData(conversationId) {
        let res = await queryBy('conversation_detail', 'conversationId', conversationId * 1)
        let conversationDetailIds = []
        res.data.forEach(async (item, index) => {
          conversationDetailIds.push(item.id)
          if (index === res.data.length - 1) {
            this.removeChatData(conversationDetailIds)
            this.removeConversationDetailData(conversationId)
          }
        });
      },
      removeConversationDetailData (conversationId) {
        deleteBy("conversation_detail", 'conversationId', conversationId)
      },
      removeChatData(conversationDetailIds) {
        conversationDetailIds.forEach(item => {
          deleteBy("chat", 'conversationDetailId', item)
        })
      },
      removeConversationData (id) {
        deleteData("conversation", id * 1)
      },
      onClickLeft() {
        this.$router.goBack();
      },
      onClickButton() {},
      onSearch(val) {
        console.log(val);
      },
      goChat(item, index) {
        if (this.isEdit) {
          let dataList = JSON.parse(JSON.stringify(this.dataList))
          if (this.selectIds.includes(item.id)) {
            this.selectIds = this.selectIds.filter(s => s != item.id)
            item.selected = false
          } else {
            this.selectIds.push(item.id)
            item.selected = true
          }
          dataList[index] = item
          this.dataList = JSON.parse(JSON.stringify(dataList))
          console.log('点击', item.id, item.selected)
        }else {
          this.$router.push({
            path: "/chat?type=" + encodeURIComponent(item.type) + '&id=' + item.id + '&class=' + item.class
          });
        }
      },
      goSubscribe() {
        this.$router.push({
          path: "/subscribe",
        });
      },
    },
  }



// WEBPACK FOOTER //
// ./src/pages/Mine/mychat.vue